import { axiosApiInstance } from "../axios";

const defaultHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

/**
 * Unauthenticated POST to API (no Bearer token, no user_id injection).
 */
export async function postForgotPassword(email) {
  const url = "forgot-password";
  try {
    const response = await axiosApiInstance.post(
      url,
      { email },
      { headers: defaultHeaders },
    );
    return {
      ok: true,
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    const res = err.response;
    return {
      ok: false,
      status: res?.status,
      data: res?.data,
    };
  }
}

export async function postResetPassword(payload) {
  const url = "reset-password";
  try {
    const response = await axiosApiInstance.post(url, payload, {
      headers: defaultHeaders,
    });
    return {
      ok: true,
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    const res = err.response;
    return {
      ok: false,
      status: res?.status,
      data: res?.data,
    };
  }
}
